import React from 'react';

import Header from '../../layout/Header.jsx';
import ListShares from '../../lists/ListShares.jsx';

const PageSharesList = () => (
  <div>
    <Header>Shares</Header>
    <ListShares />
  </div>
);

export default PageSharesList;
